<template>
  <eg-modal :show="show" @close="$emit('close')" height="150px">
    <p slot="body">
        Você não possui modeas sufientes para a aquisição desta cotação.
    </p>
    <div slot="footer">
        <eg-button @click="$emit('goToCoinPack')">
            Comprar Pacote de Moedas
        </eg-button>
    </div>
</eg-modal>
</template>

<script>
export default {
    props: {
        show: Boolean
    },
    name: 'InsufficientFunds'
};

</script>

<style>

</style>